import { useEffect, useState } from 'react';

export const getEspaiInfantilValue = () => {
    if (typeof document === 'undefined') {
        return false;
    }

    const espaiInfantilCookie = document.cookie.split('; ').find((row) => row.startsWith('espai-infantil='));

    if (!espaiInfantilCookie) {
        return false;
    }

    const [, value = ''] = espaiInfantilCookie.split('=');
    return value === '1';
};

export const isNotInfantilByCodi = (codiEspectador) => {
    let codi = codiEspectador;

    if (Array.isArray(codiEspectador)) {
        codi = codiEspectador[0]?.id ?? codiEspectador[0];
    } else if (codiEspectador && typeof codiEspectador === 'object' && 'id' in codiEspectador) {
        codi = codiEspectador.id;
    }

    if (codi === undefined || codi === null || codi === '') {
        return false;
    }

    const normalizedCodi = String(codi).replace('PUCE_', '').replace('CE_', '').replace(/^0+/, '');

    if (!normalizedCodi) {
        return false;
    }

    const value = Number(normalizedCodi);
    return Number.isFinite(value) && value > 12;
};

export const useEspaiInfantil = () => {
    const [isEspaiInfantil, setIsEspaiInfantil] = useState(null);

    useEffect(() => {
        const updateEspaiInfantil = () => setIsEspaiInfantil(getEspaiInfantilValue());

        updateEspaiInfantil();
    }, []);

    return isEspaiInfantil;
};
